import isNil from "lodash/fp/isNil";
import { saveAs } from "file-saver";
import { getCurrentDate } from "../../core/utils";
import { mapGetIds, mapKeyValue } from "../../core/transforms";
import createCorporateAdminDialogCtrl from "./corporateAdminDialog/createCorporateAdmin";
import createCorporateAdminDialogView from "./corporateAdminDialog/createCorporateAdmin.html";
import resetPasswordController from "./resetPasswordDialog/resetPasswordDialog.controller";
import resetPasswordView from "./resetPasswordDialog/resetPasswordDialog.html";
import editAdminLookerController from "./editAdminLookerDialog/editAdminLookerDialog.controller";
import editAdminLookerView from "./editAdminLookerDialog/editAdminLookerDialog.html";
import removeAdminController from "./removeAdminDialog/removeAdminDialog.controller";
import removeAdminView from "./removeAdminDialog/removeAdminDialog.html";
import officeLocationController from "./officeLocationDialog/officeLocationDialog.controller";
import officeLocationView from "./officeLocationDialog/officeLocationDialog.html";
import officeLocationDetailsController from "./officeLocationDetailsDialog/officeLocationDetailsDialog.controller";
import officeLocationDetailsView from "./officeLocationDetailsDialog/officeLocationDetailsDialog.html";
import removeOfficeLocationController from "./removeOfficeLocationDialog/removeOfficeLocationDialog.controller";
import removeOfficeLocationView from "./removeOfficeLocationDialog/removeOfficeLocationDialog.html";
import removeShiftController from "./removeShiftDialog/removeShiftDialog.controller";
import removeShiftView from "./removeShiftDialog/removeShiftDialog.html";
import constants from "../../core/constants";
import moment from "moment";

class Controller {
  constructor(
    $injector,
    $stateParams,
    Lists,
    $state,
    $mdDialog,
    $location,
    $document
  ) {
    ("ngInject");
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.activeParams = this.$stateParams;
    this.$location = $location;
    this.$mdDialog = $mdDialog;
    this.Lists = Lists;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Schedule = $injector.get("Schedule");
    this.Corporate = $injector.get("Corporate");
    this.Contracts = $injector.get("Contracts");
    this.Reservation = $injector.get("Reservation");
    this.Subscription = $injector.get("Subscription");
    this.RouteTransforms = $injector.get("RouteTransforms");
    this.sections = $injector.get("Sections").customersSections;
    this.CorporateTransforms = $injector.get("CorporateTransforms");
    this.onUpdate = this.Events.getUpdateEvent("corporate");
    this.resetPasswordEvent = this.CorporateTransforms.resetPasswordEvent;
    this.editLookerEvent = this.CorporateTransforms.editLookerEvent;
    this.removeAdminEvent = this.CorporateTransforms.removeAdminEvent;
    this.removeOfficeLocationEvent = this.CorporateTransforms.removeOfficeLocationEvent;
    this.viewOfficeLocationEvent = this.CorporateTransforms.viewOfficeLocationEvent;
    this.removeShiftEvent = this.CorporateTransforms.removeShiftEvent;
    this.addSubscriptionEvent = this.Events.getAddEvent("subscription");
    this.reservationFields = this.CorporateTransforms.reservationFields;
    this.reservationParams = { corporate: this.$stateParams.id };
    this.reservationResourceParams = {
      corporate: this.$stateParams.id,
      isCityRequired: false,
    };
    this.paginateEvent = this.Events.getPaginateEvent("reservations");
    this.invoiceParams = { corporate: $stateParams.id, isCityRequired: false };
    this.invoiceFields = this.CorporateTransforms.invoiceFields;
    this.userParams = { corporate: $stateParams.id, isCityRequired: false };
    this.userFields = this.CorporateTransforms.userFields;
    this.corporateAdminFields = this.CorporateTransforms.corporateAdminFields;
    this.successEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.reUpdateAdminsEvent = this.Events.getUpdateEvent("corporateAdmins");
    this.reUpdateOfficeLocationsEvent = this.Events.getUpdateEvent(
      "officeLocations"
    );
    this.reUpdateShiftsEvent = this.Events.getUpdateEvent("shifts");
    this.addHolidayItemEvent = this.Events.getAddEvent("corporateHolidays");
    this.addShiftItemEvent = this.Events.getAddEvent("corporateShift");
    this.addOfficeLocationItemEvent = this.Events.getAddEvent(
      "corporateOfficeLocation"
    );

    this.openOfficeLocationEvent = this.CorporateTransforms.openOfficeLocationEvent;
    this.setDefaultOfficeLocationEvent = this.CorporateTransforms.setDefaultOfficeLocationEvent;
    this.changeOfficeLocationStatusEvent = this.CorporateTransforms.changeOfficeLocationStatusEvent;
    this.corporateParams = {
      corporate: $stateParams.id,
      isCityRequired: false,
    };
    this.holidayFields = this.CorporateTransforms.holidayFields;
    this.holidayAddOptions = this.CorporateTransforms.holidayAddOptions;
    this.holidayItem = this.CorporateTransforms.holidayItem;
    this.officeLocationsFields = this.CorporateTransforms.officeLocationsFields;
    this.officeLocationsAddOptions = this.CorporateTransforms.officeLocationsAddOptions;
    this.officeLocationItem = this.CorporateTransforms.officeLocationItem;
    this.shiftsFields = this.CorporateTransforms.shiftsFields;
    this.shiftsAddOptions = this.CorporateTransforms.getShiftsAddOptions(
      $stateParams.id
    );
    this.changeShiftStatusEvent = this.CorporateTransforms.changeShiftStatusEvent;

    this.shiftItem = this.CorporateTransforms.shiftItem;
    this.shiftFilters = this.CorporateTransforms.getShiftsFilters(
      $stateParams.id
    );
    this.shiftsFilterEvent = this.Events.getFilterEvent("shifts");

    this.shiftsReservationsParams = {
      id: $stateParams.id,
      start_date: undefined,
      end_date: undefined,
      time: undefined,
    };
    this.shiftsReservationsExportFilters = this.CorporateTransforms.getShiftsFilters(
      $stateParams.id,
      true
    );

    this.shiftsReservationsFilterEvent = this.Events.getFilterEvent(
      "shifts-reservations"
    );

    // Should have the same order as the in corporate html as angularjs material only expose the tab index
    this.corporateTabs = [
      "reservations",
      "invoices",
      "user_uploads",
      "users",
      "admins",
      "holidays",
      "shifts",
      "office_locations",
    ];

    this.initialContractVersion = this.$location.search().version || null;
    this.corporateId = this.$stateParams.id;
    $document.ready(() => {
      const tabHash = this.$location.hash();
      const tabIndex = this.corporateTabs.findIndex((tab) => tab === tabHash);
      if (tabIndex !== -1) {
        this.selectedTabIndex = tabIndex;
      } else {
        this.selectedTabIndex = 0;
      }
    });
    this.isContractLoading = true;
  }

  getDateForBulkUsersUpload() {
    return getCurrentDate();
  }

  openCorporateAdminDialog() {
    this.$mdDialog.show({
      controller: createCorporateAdminDialogCtrl,
      controllerAs: "$ctrl",
      template: createCorporateAdminDialogView,
      locals: {
        corporateId: this.$stateParams.id,
      },
    });
  }

  $onInit() {
    const onUpdate = (item) => {
      // Check if it is array ?!
      // Check if it is array of objects ?!
      let isListItems;
      let isListObjects;
      if (!isNil(item[item.name])) {
        isListItems = item[item.name].listItems;
        isListObjects = item[item.name].isObject;
      }
      const updatedItem = {};
      if (isListItems && isListObjects) {
        // Send ids if array of objects
        updatedItem[item.name] = mapGetIds(item[item.name]);
      } else if (isListItems && !isListObjects) {
        // Send ids if array of strings
        updatedItem[item.name] = mapKeyValue(item[item.name]);
      } else {
        // Send value if it's string, Send id if it's object
        updatedItem[item.key] =
          typeof item.value !== "undefined"
            ? item.value
            : item.name
            ? item.name._id
            : null;
      }

      this.Corporate.update(this.$stateParams.id, updatedItem).$promise.then(
        () => {
          // As i don't need to add isDisabled to array item , only string and object
          if (!isListItems) {
            this.corporate[item.key].isDisabled = true;
          }
          this.Events.emit(
            this.successEvent,
            this.Messages.updateMessage("corporate", item.key)
          );
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.Corporate.getAllContracts({
      id: this.$stateParams.id,
      select: "version,status",
    }).$promise.then((response) => {
      this.contracts = response;
      let initialContract = null;
      if (this.initialContractVersion) {
        initialContract = this.contracts.find(
          (contract) => contract.version === Number(this.initialContractVersion)
        );
      }

      if (initialContract) {
        // If there initial contract from $location.search use it as selected
        this.Contracts.get(initialContract._id).$promise.then((response) => {
          this.isContractLoading = false;
          this.selectedContract = this.CorporateTransforms.reverseJustifyContract(
            response
          );
          this.currentVersion = this.contracts.find(
            (item) => item.version === this.selectedContract.version
          );
        });
      } else {
        this.Contracts.getActive({
          corporateId: this.$stateParams.id,
        })
          .$promise.then((response) => {
            this.isContractLoading = false;
            this.activeContract = this.CorporateTransforms.reverseJustifyContract(
              response
            );
            this.activeVersion = this.activeContract.version;

            // Else use the active one
            this.selectedContract = this.activeContract;
            this.currentVersion = this.contracts.find(
              (item) => item.version === this.activeContract.version
            );
          })
          .catch(() => {
            // No active contract then fallback to the initial one if existed
            if (initialContract) {
              this.Contracts.get(initialContract._id).$promise.then(
                (response) => {
                  this.selectedContract = this.CorporateTransforms.reverseJustifyContract(
                    response
                  );
                  this.currentVersion = this.contracts.find(
                    (item) => item.version === this.selectedContract.version
                  );
                }
              );
            }
          });
      }
    });

    this.downloadLastBulkUsers = () => {
      this.Corporate.getLastBulkUpload({
        corporate_id: this.$stateParams.id,
        upload_id: this.corporate.bulk_users_details._id,
        type: "users",
      }).$promise.then(
        (response) => {
          const fileName = `corporate-${this.$stateParams.id}-${
            this.corporate.bulk_users_details.file_name
          }-${getCurrentDate()}.csv`;
          const file = new File([response.file_data], fileName);
          saveAs(file);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.downloadBulkUsersTemplate = () => {
      const fileName = "BulkUploadUsersTemplate.csv";
      const fileHeader = ["name, email, phone"];
      const file = new File(fileHeader, fileName);
      saveAs(file);
    };

    this.Corporate.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.corporate = this.CorporateTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    this.resetCorporateAdminPassword = (admin) => {
      const resetPasswordDialog = this.$mdDialog.show({
        controller: resetPasswordController,
        controllerAs: "$ctrl",
        template: resetPasswordView,
        locals: {
          admin: { ...admin, corporateName: this.corporate.name.value },
        },
      });

      resetPasswordDialog.then(
        () => {
          this.Corporate.resetAdminPassword(
            this.$stateParams.id,
            admin
          ).$promise.then(
            () => {
              this.Events.emit(this.successEvent, {
                message: "Reset password successfully",
              });
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.openEditAdminLookerRolesDialog = (admin) => {
      this.$mdDialog.show({
        controller: editAdminLookerController,
        controllerAs: "$ctrl",
        template: editAdminLookerView,
        locals: {
          admin,
          reUpdateAdminsEvent: this.reUpdateAdminsEvent,
        },
      });
    };

    this.removeCorporateAdmin = (admin) => {
      const removeAdminDialog = this.$mdDialog.show({
        controller: removeAdminController,
        controllerAs: "$ctrl",
        template: removeAdminView,
        locals: {
          admin: { ...admin, corporateName: this.corporate.name.value },
        },
      });

      removeAdminDialog.then(
        () => {
          this.Corporate.removeAdmin(this.$stateParams.id, admin).$promise.then(
            () => {
              this.Events.emit(this.successEvent, {
                message: "Admin removed successfully",
              });
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.removeOfficeLocation = (officeLocation) => {
      const removeOfficeLocationDialog = this.$mdDialog.show({
        controller: removeOfficeLocationController,
        controllerAs: "$ctrl",
        template: removeOfficeLocationView,
        locals: {
          officeLocation: {
            ...officeLocation,
            corporateName: this.corporate.name.value,
          },
        },
      });

      removeOfficeLocationDialog.then(
        () => {
          this.Corporate.removeOfficeLocation(
            this.$stateParams.id,
            officeLocation
          ).$promise.then(
            () => {
              this.Events.emit(this.successEvent, {
                message: "Office location removed successfully",
              });
              this.Events.emit(this.reUpdateOfficeLocationsEvent);
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.removeShift = (shift) => {
      const removeShiftDialog = this.$mdDialog.show({
        controller: removeShiftController,
        controllerAs: "$ctrl",
        template: removeShiftView,
        locals: {
          shift: {
            ...shift,
            corporateName: this.corporate.name.value,
          },
        },
      });

      removeShiftDialog.then(
        () => {
          this.Corporate.removeShift(this.$stateParams.id, shift).$promise.then(
            () => {
              this.Events.emit(this.successEvent, {
                message: "Shift removed successfully",
              });
              this.Events.emit(this.reUpdateShiftsEvent);
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.viewOfficeLocation = (officeLocation) => {
      this.$mdDialog.show({
        controller: officeLocationDetailsController,
        controllerAs: "$ctrl",
        template: officeLocationDetailsView,
        locals: {
          officeLocationDetails: officeLocation,
          corporateId: this.$stateParams.id,
          reUpdateOfficeLocationsEvent: this.reUpdateOfficeLocationsEvent,
        },
      });
    };

    this.openOfficeLocation = (officeLocation) => {
      this.$mdDialog.show({
        controller: officeLocationController,
        controllerAs: "$ctrl",
        template: officeLocationView,
        locals: {
          officeLocationCoords: officeLocation.coords.split(","),
        },
      });
    };

    this.setDefaultOfficeLocation = (officeLocation) => {
      this.Corporate.setDefaultOfficeLocation(
        this.$stateParams.id,
        officeLocation
      ).$promise.then(
        () => {
          this.Events.emit(this.successEvent, {
            message: "Default office location has been set successfully",
          });
        },
        (response) => {
          this.Events.emit(this.errorEvent, response.data);
          this.Events.emit(this.reUpdateOfficeLocationsEvent);
        }
      );
    };

    this.changeShiftStatus = (shift) => {
      const statusText = shift.is_active ? "activated" : "deactivated";
      this.Corporate.changeShiftStatus(
        this.$stateParams.id,
        shift
      ).$promise.then(
        () => {
          this.Events.emit(this.successEvent, {
            message: `Shift has been ${statusText} successfully`,
          });
        },
        (response) => {
          this.Events.emit(this.errorEvent, response.data);
          this.Events.emit(this.reUpdateShiftsEvent);
        }
      );
    };

    this.changeOfficeLocationStatus = (officeLocation) => {
      const statusText = officeLocation.is_active ? "activated" : "deactivated";
      this.Corporate.changeOfficeLocationStatus(
        this.$stateParams.id,
        officeLocation
      ).$promise.then(
        () => {
          this.Events.emit(this.successEvent, {
            message: `Office location has been ${statusText} successfully`,
          });
        },
        (response) => {
          this.Events.emit(this.errorEvent, response.data);
          this.Events.emit(this.reUpdateOfficeLocationsEvent);
        }
      );
    };

    this.onChangeShiftType = (value) => {
      this.Corporate.update(this.$stateParams.id, {
        shift_type: value,
      }).$promise.then(
        () => {
          this.Events.emit(
            this.successEvent,
            this.Messages.updateMessage("corporate", "shift type")
          );
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.onToggleAllowDeleteAllEmployees = () => {
      const modelValue = this.corporate.allow_delete_all_business_profiles
        .value;
      this.Corporate.update(this.$stateParams.id, {
        allow_delete_all_business_profiles: modelValue,
      }).$promise.then(
        () => {
          this.Events.emit(
            this.successEvent,
            this.Messages.updateMessage(
              "corporate",
              "enable delete all employees"
            )
          );
        },
        (response) => {
          this.Events.emit(this.errorEvent, response.data);
          this.corporate.allow_delete_all_business_profiles.value = !modelValue;
        }
      );
    };

    this.onChangeShiftsReservationsFilters = (data) => {
      this.shiftsReservationsParams = {
        ...this.shiftsReservationsParams,
        ...(data.start_date !== undefined &&
          data.end_date !== undefined && {
            start_date: data.start_date || data.date,
            end_date: data.end_date || data.date,
          }),
        ...(data.time !== undefined && {
          time: data.time,
        }),
      };

      this.validateShiftReservationsExport =
        this.shiftsReservationsParams.start_date &&
        this.shiftsReservationsParams.end_date &&
        this.shiftsReservationsParams.time;
    };
    this.exportShiftsReservations = () => {
      const startDate = moment(this.shiftsReservationsParams.start_date).format(
        constants.dateFormat
      );
      const endDate = moment(this.shiftsReservationsParams.end_date).format(
        constants.dateFormat
      );
      this.Corporate.exportAllShiftsReservations({
        id: this.shiftsReservationsParams.id,
        start_date: startDate,
        end_date: endDate,
        shift_times: this.shiftsReservationsParams.time,
        isCityRequired: false,
      }).$promise.then(
        (response) => {
          const fileName = `${
            this.corporate.name.value
          }_shift-reservations-${startDate}-${endDate}-${Date.now()}.csv`;
          const file = new File([response.data], fileName);
          saveAs(file);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.Events.on(this.onUpdate, onUpdate);
    this.Events.on(this.resetPasswordEvent, this.resetCorporateAdminPassword);
    this.Events.on(this.editLookerEvent, this.openEditAdminLookerRolesDialog);
    this.Events.on(this.removeAdminEvent, this.removeCorporateAdmin);
    this.Events.on(this.openOfficeLocationEvent, this.openOfficeLocation);
    this.Events.on(this.removeOfficeLocationEvent, this.removeOfficeLocation);
    this.Events.on(this.viewOfficeLocationEvent, this.viewOfficeLocation);
    this.Events.on(this.removeShiftEvent, this.removeShift);
    this.Events.on(
      this.setDefaultOfficeLocationEvent,
      this.setDefaultOfficeLocation
    );
    this.Events.on(
      this.changeOfficeLocationStatusEvent,
      this.changeOfficeLocationStatus
    );
    this.Events.on(this.changeShiftStatusEvent, this.changeShiftStatus);
    this.Events.on(
      this.shiftsReservationsFilterEvent,
      this.onChangeShiftsReservationsFilters
    );
  }

  $onDestroy() {
    if (!isNil(this.resetPasswordEvent)) {
      this.Events.off(
        this.resetPasswordEvent,
        this.resetCorporateAdminPassword
      );
    }

    if (!isNil(this.editLookerEvent)) {
      this.Events.off(this.editLookerEvent, this.editCorporateAdminLookerRoles);
    }

    if (!isNil(this.removeAdminEvent)) {
      this.Events.off(this.removeAdminEvent, this.removeCorporateAdmin);
    }

    if (!isNil(this.openOfficeLocationEvent)) {
      this.Events.off(this.openOfficeLocationEvent, this.openOfficeLocation);
    }

    if (!isNil(this.removeOfficeLocationEvent)) {
      this.Events.off(
        this.removeOfficeLocationEvent,
        this.removeOfficeLocation
      );
    }

    if (!isNil(this.removeShiftEvent)) {
      this.Events.off(this.removeShiftEvent, this.removeShift);
    }

    if (!isNil(this.setDefaultOfficeLocationEvent)) {
      this.Events.off(
        this.setDefaultOfficeLocationEvent,
        this.setDefaultOfficeLocation
      );
    }

    if (!isNil(this.changeOfficeLocationStatusEvent)) {
      this.Events.off(
        this.changeOfficeLocationStatusEvent,
        this.changeOfficeLocationStatus
      );
    }

    if (!isNil(this.changeShiftStatusEvent)) {
      this.Events.off(this.changeShiftStatusEvent, this.changeShiftStatus);
    }
  }

  onToggleAllowSkipStation() {
    const confirm = this.$mdDialog
      .confirm()
      .title(
        `Are you sure you want to ${
          this.corporate.allow_skip_station.value ? "allow" : "prohibit"
        } skipping stations?`
      )
      .ok("Confirm")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(
      () => {
        this.Corporate.update(this.$stateParams.id, {
          allow_skip_station: this.corporate.allow_skip_station.value,
        }).$promise.then(
          () => {
            this.Events.emit(this.successEvent, {
              message: `Skip station is ${
                this.corporate.allow_skip_station.value
                  ? "allowed"
                  : "prohibited"
              } successfully`,
            });
          },
          (response) => {
            this.Events.emit(this.errorEvent, response.data);
            this.corporate.allow_skip_station.value = !this.corporate
              .allow_skip_station.value;
          }
        );
      },
      () => {
        this.corporate.allow_skip_station.value = !this.corporate
          .allow_skip_station.value;
      }
    );
  }

  preToggleAllowSkipStation() {
    const confirm = this.$mdDialog
      .confirm()
      .title(
        `Are you sure you want to ${
          this.corporate.allow_skip_station_with_bookings.value
            ? "allow"
            : "prohibit"
        } skipping stations with bookings?`
      )
      .ok("Confirm")
      .cancel("Cancel");

    this.$mdDialog
      .show(confirm)
      .then(this.toggleAllowSkipStation.bind(this), () => {
        this.corporate.allow_skip_station_with_bookings.value = !this.corporate
          .allow_skip_station_with_bookings.value;
      });
  }

  toggleAllowSkipStation() {
    this.Corporate.update(this.$stateParams.id, {
      allow_skip_station_with_bookings: this.corporate
        .allow_skip_station_with_bookings.value,
    }).$promise.then(
      () => {
        this.Events.emit(this.successEvent, {
          message: `Skip station is ${
            this.corporate.allow_skip_station_with_bookings.value
              ? "allowed"
              : "prohibited"
          } successfully`,
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/corporate.controller.js